import { createSelector } from 'reselect';
const isBot = privilege => ['bot', 'bot:smartguide'].includes(privilege);

const combSelectAgentGroupToken = createSelector(
  [agentList => agentList, (agentList, agentGroupList) => agentGroupList],
  (agentList, agentGroupList) => {
    const agentOption = agentList.map(val => ({ ...val, label: val.realname || val.nickname, value: val.token }));
    return agentGroupList
      .map(group => {
        const children = agentOption.filter(val => val.group_id === group.id);

        if (children && children.length > 0) {
          return { ...group, label: group.name, value: group.token, children };
        }
        return null;
      })
      .filter(val => val);
  }
);

const combSelectAgentGroupId = createSelector([agents => agents, (agents, groups) => groups], (agents, groups) => {
  const agentOption = agents.map(val => ({ ...val, label: val.realname, value: val.id }));
  return groups
    .map(group => {
      const children = agentOption.filter(val => val.group_id === group.id);

      if (children && children.length > 0) {
        return { ...group, label: group.name, value: group.id, children };
      }
      return null;
    })
    .filter(val => val);
});

const defaultConfig = {
  withRobotGroup: true,
  withEmptyGroup: false
};

const combTreeAgentGroup = createSelector(
  [
    agentList => agentList,
    (agentList, agentGroupList) => agentGroupList,
    (agentList, agentGroupList, config) => config || defaultConfig
  ],
  (agentList, agentGroupList, config) => {
    const { withRobotGroup = true, withEmptyGroup = false, withAvatar = false } = config;
    const filterBot = agentList.filter(agent => !isBot(agent.privilege));
    const list = [];
    agentGroupList.forEach(group => {
      const { id, name, prevName } = group;
      const targetList = withRobotGroup ? agentList : filterBot;
      const childList = targetList.filter(agent => agent.group_id === id);
      if (childList.length) {
        const isRobot = ['__ROBOTS__', '__ROBOTS__ '].includes(prevName);
        const listItem = {
          title: name,
          label: name,
          value: isRobot ? 'group_bot' : id,
          key: isRobot ? 'group_bot' : id,
          children: childList.map(child => {
            const childItem = {
              label: child.realname || child.nickname,
              title: child.realname || child.nickname,
              key: child.id,
              value: child.id,
              id
            };
            if (withAvatar) childItem.avatar = child.avatar;
            return childItem;
          })
        };
        if (isRobot) listItem.group_id = 'group_bot';
        else listItem.id = id;

        list.push(listItem);
      } else if (withEmptyGroup) {
        list.push({
          title: name,
          label: name,
          value: id,
          key: id,
          id,
          children: []
        });
      }
    });
    return list;
  }
);

export default { combSelectAgentGroupToken, combTreeAgentGroup, combSelectAgentGroupId };
